import { get } from "lodash";
import { MdClose } from "react-icons/md";
import { CURRENCY_SYMBOL } from "utils/constants";
import Button from "../../../../Button";
import Cost from "../../../../Cost";

function View({ onSubmit, onClose, generalCost, upsells, totalAmount }) {
  return (
    <div className="amellis__help--modal">
      <div className="grid--1">
        <div className="amellis__help--title">Votre panier</div>
        <div className="cart__card">
          <h3>{get(generalCost, "insurancePlan.name")}</h3>
          <Cost
            cost={totalAmount}
            currency={get(generalCost, "currency")}
            // showYearly
          />
        </div>
      </div>
      <div className="d-flex gap-16">
        <div className="flex--grow-1">
          <Button type={"primary"} onClick={onSubmit}>
            Modifier
          </Button>
        </div>
        <div className="flex--grow-1">
          <Button block type={"primary-light"} onClick={onClose}>
            <MdClose /> Fermer
          </Button>
        </div>
      </div>
    </div>
  );
}

export default View;
